var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronDown16 = function SvgChevronDown16(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#36354C",
    d: "M8.354 10.647a.5.5 0 0 1-.708 0L3.35 6.351a.495.495 0 1 1 .7-.7L8 9.6l3.95-3.95a.495.495 0 1 1 .7.7z"
  })));
};
export default SvgChevronDown16;